export default __webpack_public_path__ + "2d62d8e4b759e3d6f768166c906e7bce.png";